import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  (theme) => ({
    root: {
      display: 'flex',
      flexFlow: 'row nowrap',
    },
    briefName: {
      flex: 'auto',
      textOverflow: 'ellipsis',
      whiteSpace: 'nowrap',
      overflow: 'hidden',
    },
    icon: {
      fontSize: theme.typography.pxToRem(16),
      marginRight: theme.spacing(1),
    },
  }),
  { name: 'ProjectFolderDescription' }
);
